'use client'

import type { ReactiveVar } from '@apollo/client'
import { makeVar, useQuery } from '@apollo/client'

import { MY_DETAILS } from '../data/queries/user'
import type { MeReturnType } from '../types/user'

export const userDetailsVar = makeVar(null) as ReactiveVar<MeReturnType | null>

export const useUserQuery = () => {
  const {
    data: userDetails,
    loading,
    refetch
  } = useQuery(MY_DETAILS, {
    fetchPolicy: 'cache-first'
  })

  const myDetails: MeReturnType = userDetails ? userDetails.me : {}

  return { loading, myDetails, refetchUserDetails: refetch }
}
